import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button } from "@material-ui/core";
import { buildZendeskLink } from "src/store/adminHtml/selector";
import { openZendeskWithSSO } from "src/utils/zendeskSso";
import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "src/store/system/selector";

const useStyles = makeStyles((theme) => ({
  minimalMarginBottom: {
    marginBottom: "10px",
  },
  importantText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  headerText: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textField: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
}));

interface UsingOtherProductDialogProps {
  cancellationReason: string;
  setCancellationReason: (reason: string) => void;
}

function UsingOtherProductDialog(props: UsingOtherProductDialogProps) {
  const classes = useStyles();
  const user = useSelector(selectUser);
  if (!user) return null;

  return (
    <div>
      <Typography variant="h4" className={classes.headerText}>
        Do you know about some of the features that make My Reseller Genie
        unique?
      </Typography>
      <Typography variant="body1">
        Our amazing customer support team is here to serve you and find
        solutions. Feel free to send them an email to talk through any problems
        you’re experiencing. My Reseller Genie is helping a lot of resellers,
        and we’d love to help you too!
      </Typography>
      <div style={{ paddingTop: "1rem" }}>
        <Button
          color="primary"
          variant="contained"
          onClick={() =>
            openZendeskWithSSO(
              buildZendeskLink(
                user,
                "What features does MRG have that other products don't?",
                "Please use this description box to outline features you are looking for that we may possibly provide:",
                "cancellationReason:usingOtherProductAction",
                "cancelation"
              )
            )
          }
        >
          Contact Support
        </Button>
      </div>
      <div style={{ paddingTop: "1rem" }}>
        <Typography>
          <Box component="span" fontWeight="fontWeightMedium">
            Before you click Cancel Subscription,
          </Box>{" "}
          please let us know -- what other product(s) are you using?
        </Typography>
      </div>
      <TextField
        id="filled-basic"
        label="Describe the Product"
        variant="filled"
        className={classes.textField}
        value={props.cancellationReason}
        onChange={(event) => {
          props.setCancellationReason(event.target.value);
        }}
      />
    </div>
  );
}

export default UsingOtherProductDialog;
